import styled from 'styled-components';

export const InnerDialogWrapper = styled.div<{
  paddingX?: string;
}>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 ${(p) => (p.paddingX ? p.paddingX : 0)};
  width: 100%;
`;
